import { render, staticRenderFns } from "./InputFrame.vue?vue&type=template&id=36632cac&scoped=true&"
import script from "./InputFrame.vue?vue&type=script&lang=js&"
export * from "./InputFrame.vue?vue&type=script&lang=js&"
import style0 from "./InputFrame.vue?vue&type=style&index=0&id=36632cac&prod&scoped=true&lang=css&"
import style1 from "./InputFrame.vue?vue&type=style&index=1&id=36632cac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36632cac",
  null
  
)

export default component.exports